import React from 'react';
import { useAuth } from '../context/AuthContext';

interface SidebarProps {
  /** Handler for the Create Gantt action. */
  onCreateGantt: () => void;
  onNewRecord: () => void;
  onVendor: () => void;
  onDistro: () => void;
  onReports: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({
  onCreateGantt,
  onNewRecord,
  onVendor,
  onDistro,
  onReports,
}) => {
  const { isViewer } = useAuth();

  return (
    <aside className="sidebar-actions">
      <button className="btn btn-secondary" onClick={onCreateGantt}>
        Create Gantt
      </button>
      <button className="btn btn-secondary" onClick={onReports}>
        Reports
      </button>
      {!isViewer && (
        <>
          <button className="btn btn-secondary" onClick={onNewRecord}>
            New Record
          </button>
          <button className="btn btn-secondary" onClick={onVendor}>
            Vendor
          </button>
          <button className="btn btn-secondary" onClick={onDistro}>
            Distro List
          </button>
        </>
      )}
    </aside>
  );
};

export default Sidebar;
